import {
  type StoreExtensionContext,
  StoreExtensionProvider,
} from '@blocksuite/affine-ext-loader';
import {
  ColumnBlockSchemaExtension,
  ColumnsBlockSchemaExtension,
} from '@blocksuite/affine-model';

import {
  ColumnBlockHtmlAdapterExtension,
  ColumnsBlockHtmlAdapterExtension,
} from './adapters/html';
import {
  ColumnBlockMarkdownAdapterExtension,
  ColumnsBlockMarkdownAdapterExtension,
} from './adapters/markdown';
import {
  ColumnBlockPlainTextAdapterExtension,
  ColumnsBlockPlainTextAdapterExtension,
} from './adapters/plain-text';

export class ColumnsStoreExtension extends StoreExtensionProvider {
  override name = 'affine-columns-block';

  override setup(context: StoreExtensionContext) {
    super.setup(context);
    context.register(ColumnsBlockSchemaExtension);
    context.register(ColumnBlockSchemaExtension);
    context.register(ColumnsBlockMarkdownAdapterExtension);
    context.register(ColumnBlockMarkdownAdapterExtension);
    context.register(ColumnsBlockPlainTextAdapterExtension);
    context.register(ColumnBlockPlainTextAdapterExtension);
    context.register(ColumnsBlockHtmlAdapterExtension);
    context.register(ColumnBlockHtmlAdapterExtension);
  }
}
